import React from "react";

const LoadingJobsSection = ({ content }) => {
  return (
    <section className="page-section page-section-tight">
      <div className="container">
        <div className="loading-state" role="status" aria-live="polite">
          <span className="loading-dot"></span>
          <span>{content}</span>
        </div>
      </div>
    </section>
  );
};

export default LoadingJobsSection;
